import * as React from 'react';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { dataGridStyles } from './dataGridStyles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { 
  DataGridPro,
  GridToolbar,
   } from '@mui/x-data-grid-pro';


export default function SimpleGrid(props) {

  //if no props filter model is passed, set it to empty
  const [selectedModel, setSelectedModel ] = React.useState();
  const  GridData  = {
    columns: props.gridColumns, 
    rows: props.gridData
    };
  

  return (
    <Grid container
      sx={{ 
        display: 'flex',
        width: "100%",
        height: "100%",
        border: 0,
        justifyContent: 'flex-start',
        direction: 'row',
        overflow: 'hidden',

      }}>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{alignContent: 'center', justifyContent:'center', border: 0, pt:1}}>
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Typography variant="h6" gutterBottom center >Cycle Counts Metrics</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} sx={{alignContent: 'center', height:'500px', border: 0}}>
      <DataGridPro

        sx={dataGridStyles.root}
        pagination
        initialState={{
          pageSize: 10,
          columns: {
            columnVisibilityModel: props.visibleColumns,
          },
          sorting: {
            sortModel: [ props.sortModel ],
          },
          pinnedColumns: {left: props.pinnedColumns},
        }}
        slots={{toolbar: GridToolbar}}
      onSelectionModelChange={(newSelectionModel) => {
        setSelectedModel(newSelectionModel)
        // props.handleMarketFileNames(newSelectionModel)
      }}
      selectedModel={selectedModel}
      {...GridData} 
      />
        </Grid>
      </Grid>

  );
};